module.exports = "<div class=\"color-picker-container\">\n  <div *ngFor=\"let t of themes\">\n    <div class=\"color-item\" [ngClass]=\"t.theme\" (click)=\"setTheme(t.theme)\" [id]=\"getName(t)\" [class.selected]=\"t.theme === themeSelected\">\n      <span class=\"oi oi-check check-icon-picker\"></span>\n    </div>\n    <div class=\"color-picker-name\">\n      {{t.name}}\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/theme-color-picker/theme-color-picker.component.html
// module id = ../../../../../src/app/theme-color-picker/theme-color-picker.component.html
// module chunks = main